"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getConsultantInfoUtilityClass = getConsultantInfoUtilityClass;
var _base = require("@ori-ui/mui-bundle/base");
function getConsultantInfoUtilityClass(slot) {
  return (0, _base.generateUtilityClass)('MuiOriConsultantInfo', slot);
}
const consultantInfoClasses = (0, _base.generateUtilityClasses)('MuiOriConsultantInfo', ['root', 'consultantTitle', 'profilePicture', 'consultantName', 'consultantNumber', 'content', 'sizeLarge', 'sizeMedium', 'avatarIcon']);
var _default = exports.default = consultantInfoClasses;
//# sourceMappingURL=consultantInfoClasses.js.map